module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABHUlEQVRIS+2Wu06CQRBGz0eQip6ERt5AK0nsKO2wI+FleBQfwcLEAhJjgiZeCqC1J1YUViaarNmGbH4W/mFZLAjb7syeue3MiH8+KvKccydAE1i522Dbp6Rvi+0x4BXQtigHMgvgRtJXmV4M2AXOyxSD+1+gCpigOYCPQAs4tUBzAIfAG9C3QLMAJT0552oWaDagz6kFmgPoc/gaFJH3tAc0gHdJd2EB5gBuKuiJpNsjcNuPnz2kU+DZ2HkugbNANimHvgIfjMAOcLEr0MiKiiV5+AMUR4//TnWDJUnAsaRRZG4O9gX8AGaFxyvA9b6AhnfXiiSF9AjM3mkOL6Qpa+K6KLxIui+bhymLcAzogLkk36mWZ5vtepdcLnX/AGK1ph2TyXiKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/top_icon_device_nor.png
// module id = Eq9L
// module chunks = 19